require('../../../scroll-into-view-polyfill');
require('./array-includes-polyfill');

var moment = require("moment");

function sortWeekdays(usDay) {
    var euDay = 0;
    if (usDay == 0) {
        euDay = 6;
    } else {
        euDay = usDay - 1;
    }
    return euDay;
}

function renderDays(current, empty, startDay, endDay, callback, secondStartDay, booked) {

    var dayHtml = document.createElement("div");

    if (empty) {
        dayHtml.className = "day unavailable empty-day";
        dayHtml.innerHTML = "";
        return dayHtml;
    }
    else {

        eventStart = startDay.date();
        eventEnd = endDay;

        var passed = moment(current).add(-1, 'days').minutes(0).hours(7);
        var deadlinePassed = moment().isAfter(passed);

        var day = current.date();

        if (booked || deadlinePassed) {
            dayHtml.className = "day unavailable";
            dayHtml.innerHTML = day;
        } else {

            if (current.isSameOrAfter(startDay) && current.isSameOrBefore(endDay)) {

                dayHtml.innerHTML = day;

                if (current.isBefore(moment())) {
                    dayHtml.className = "day passed";
                } else {
                    dayHtml.className = "day available";
                    dayHtml.addEventListener('click', function (_) {
                        var previousPick = document.getElementsByClassName("testdrive-selected-day");
                        if (previousPick) {
                            for (var i = 0; i < previousPick.length; i++) {
                                previousPick[i].removeAttribute("data-selected");
                                previousPick[i].removeAttribute("data-selected-testdrive-day");
                                previousPick[i].className = "day available";
                            }
                        }
                        dayHtml.className = "day testdrive-selected-day";
                        dayHtml.setAttribute("data-selected-testdrive-day", day);
                        callback(current); // moment(startDay).set({date: day}));
                    });
                }
            } else {
                dayHtml.className = "day unavailable";
                dayHtml.innerHTML = day;
            }
        }
        return dayHtml;
    }
}

function renderCar(car, empty) {

    var carHtml = document.createElement("div");
    if (empty) {
        carHtml.className = "car unavailable";
        carHtml.innerHTML = "";
        return carHtml;
    } else if (car) {
        carHtml.className = "car available";

        var carImage = document.createElement("div");
        carHtml.appendChild(carImage);
        carImage.innerHTML = '<img src="' + car.image + '" />';
        carImage.className = "car-image";

        var carModel = document.createElement("div");
        carHtml.appendChild(carModel);
        carModel.innerHTML = car.model;
        carModel.className = "car-model";

        carHtml.addEventListener('click', function (e) {
            carHtml.className = "car choosed-car";
        })
    }
    return carHtml;
}


function getFirstWeekdayOfMonth(date) {
    var startOfMonthDate = moment(date);
    startOfMonthDate.set({ date: 1 });
    var firstWeekdayOfMonth = sortWeekdays(startOfMonthDate.day());
    return firstWeekdayOfMonth;
}

function dayBooked(current, booked, unavailableTimes) {
    if (unavailableTimes.includes(current.format('YYYY-MM-DD'))) {
        return true;
    }
    var bookedDay = booked[current.format('YYYY-MM-DD')];
    var allBooked = bookedDay && bookedDay.length > 0 && bookedDay[0].cars && bookedDay[0].cars.length === 0;
    return allBooked;
}

function renderMonth(startDay, endDay, endOfEvent, booked, unavailableTimes, dayCallback) {

    var currentActiveMonth = 0;
    var months = ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"];
    var secondEndDay = endOfEvent;
    var monthsBox = document.createElement("div");
    var monthsContainer = document.createElement("div");
    monthsContainer.className = "month-list";
    monthsBox.className = "month-box";

    var startMonth = startDay.month(); 
    var endMonth = endDay.month(); 

    var allMonthElements = [];

    for(i = startMonth; i <= endMonth; i++) {

        var current = moment(startDay);
        current.month(i);

        var singleMonthElement = document.createElement('div');
        singleMonthElement.className = "month";

        var monthLabel = document.createElement("div");
        monthLabel.className = 'month-label';
        var monthTitleElement = document.createElement('div');
        monthTitleElement.innerHTML = months[i];
        monthLabel.appendChild(monthTitleElement);
        singleMonthElement.appendChild(monthLabel);

        allMonthElements.push(singleMonthElement);

        var weeksElement = document.createElement('div');
        weeksElement.className = 'weeks';
        weeksElement.innerHTML = "<div class='week-day'>Må</div><div class='week-day'>Ti</div><div class='week-day'>On</div><div class='week-day'>To</div><div class='week-day'>Fr</div><div class='week-day'>Lö</div><div class='week-day'>Sö</div>";
        singleMonthElement.appendChild(weeksElement);
        var daysContainer = document.createElement('div');
        daysContainer.className = "days";
        singleMonthElement.appendChild(daysContainer);

        var startOfMonth = moment(current).startOf('month');
        var endOfMonth = moment(current).endOf('month');

        var monthDayStart = startOfMonth.date();
        var monthDayEnd = endOfMonth.date();

        var startOfWeek = getFirstWeekdayOfMonth(startOfMonth);

        for (j = 1; j <= startOfWeek; j++) {
            var date = moment(current).date(1).add(-j, 'days');
            var allBooked = dayBooked(date, booked, unavailableTimes);
            var oneDay = renderDays(date, true, startDay, endDay, dayCallback, false, allBooked);
            daysContainer.appendChild(oneDay);
        }

        for (j = monthDayStart; j <= monthDayEnd; j++) {
            var date = moment(current).date(j);
            var allBooked = dayBooked(date, booked, unavailableTimes);
            var oneDay = renderDays(date, false, startDay, endDay, dayCallback, false, allBooked);
            daysContainer.appendChild(oneDay);
        }

        monthsContainer.appendChild(singleMonthElement);

    }

    var monthNavigation = document.createElement('div');
    var monthLeft = document.createElement('div');
    var monthRight = document.createElement('div');
    monthLeft.innerHTML = '&lt;';
    monthRight.innerHTML = '&gt;';
    monthNavigation.className = 'month-navigation';
    monthLeft.className = 'month-navigation-left';
    monthRight.className = 'month-navigation-right';
    monthNavigation.appendChild(monthLeft);
    monthNavigation.appendChild(monthRight);

    if (allMonthElements.length > 1) {

        monthLeft.style.display = 'none';
        monthRight.addEventListener('click', function(_) {
            currentActiveMonth = currentActiveMonth + 1 > allMonthElements.length  - 1 ? 0 : currentActiveMonth + 1;
            allMonthElements[currentActiveMonth].scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            monthLeft.style.display = '';
            if (currentActiveMonth > allMonthElements.length - 2) {
                monthRight.style.display = 'none';
            }
        });

        monthLeft.addEventListener('click', function(_) {
            currentActiveMonth = currentActiveMonth - 1 < 0 ? allMonthElements.length - 1 : currentActiveMonth - 1;
            allMonthElements[currentActiveMonth].scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            monthRight.style.display = '';
            if (currentActiveMonth === 0) {
                monthLeft.style.display = 'none';
            }
         });

    }


    monthsBox.appendChild(monthNavigation);
    monthsBox.appendChild(monthsContainer);
    return monthsBox;

}

function renderSlots(container, day, date, onClick) {

    var middleTime = moment('12:00', 'HH:mm')

    var beforeContainer = null;
    var afterContainer = null;

    container.innerHTML = '';

    for ( var i = 0, ii = day.length; i < ii; i++ ) {

        var slot = day[i];

        (function(slot) {

            var startTime = moment(slot.start, 'HH:mm');
            var endTime = moment(slot.start, 'HH:mm');

            if (startTime.diff(middleTime, 'minutes') <= 0) {

                if (!beforeContainer) {

                    beforeContainer = document.createElement('div');
                    beforeContainer.classList.add('hours-box');
                    beforeContainer.classList.add('am');

                    var title = document.createElement('h3');
                    title.innerHTML = 'På morgonen';
                    beforeContainer.appendChild(title);

                    container.appendChild(beforeContainer);

                }

                var slotElement = document.createElement('div');
                if (slot.cars.length > 0) {
                    beforeContainer.appendChild(slotElement);
                }

            } else {

                if (!afterContainer) {

                    afterContainer = document.createElement('div');
                    afterContainer.classList.add('hours-box');
                    afterContainer.classList.add('pm');

                    var title = document.createElement('h3');
                    title.innerHTML = 'På eftermiddagen';
                    afterContainer.appendChild(title);

                    container.appendChild(afterContainer);

                }

                var slotElement = document.createElement('div');
                if (slot.cars.length > 0) {
                    afterContainer.appendChild(slotElement);
                }

            }

            slotElement.classList.add('hour');
            slotElement.innerHTML = startTime.format('HH:mm');
            slotElement.setAttribute('data-slot-ids', slot.cars.join('|'));

            var isafter = moment().isAfter(date);
            if (slot.cars.length > 0) {
                if ((moment().date() == date.date() && startTime.utc() >= moment().utc()) || !isafter) {
                    slotElement.addEventListener('click', function() {
                        var oldList = container.querySelectorAll('.hour.choosed-time');
                        for ( var i = 0, ii = oldList.length; i < ii; i++ ) {
                            oldList[i].classList.remove('choosed-time');
                        }
                        this.classList.add('choosed-time');
                        onClick(slot.cars[0]);
                    });
                } else {
                    slotElement.classList.add('passed');
                }
            } else {
                slotElement.classList.add('unavailable');
            }

        })(slot);

    }

}

function renderCalendar(formRoot, context, cars, startDate, endDate, slotLength, unavailable, onSlotClick) {

    var endOfEvent = endDate.date();
    var fields = [];

    var fieldNamesToHide = [
        'firstname',
        'lastname',
        'email',
        'mobile',
        'address',
        'district',
        'gdprtext',
        'input',
        'submit'
    ];

    const unavailableTimes = (unavailable || '').replace(/ /i, '').replace(/(\n|\r)/i, ',').split(',').filter(function(time) {
        return moment(time).isValid();
    });
    console.log('u', unavailable, unavailableTimes);

    var children = formRoot.querySelector('#render-container').childNodes;
    var found = false;

    for ( var i = 0, ii = children.length; i < ii; i++ ) {
        var element = children[i];
        if (found && element.style) {
            fields.push(element);
        }
        if (element === context) {
            found = true;
        }
    }

    for ( var i = 0, ii = fields.length; i < ii; i++ ) {
        fields[i].style.display = 'none';
    }

    var eventCalendarContainer = context.querySelector('[data-event-calendar-container]');
    var eventSlotsContainer = context.querySelector('[data-event-slots-container]');
    var eventSlotsListContainer = context.querySelector('[data-event-slots-list-container]');
    var eventCalendar = context.querySelector('[data-calendar-renderer]');
    var eventCarsContainer = context.querySelector('[data-car-renderer]');

    if (eventCarsContainer && eventCalendar) {

        for (var i = 0; i < cars.length; i++) {

            var car = cars[i];

            (function (car) {
                var carElement = renderCar(car);
                carElement.addEventListener('click', function(e) {

                    if (eventCalendar) {
                        var oneMonth = renderMonth(startDate, endDate, endOfEvent, car.days, unavailableTimes, function(day) {

                            var currentDay = car.days[day.format('YYYY-MM-DD')];

                            // Special case for 24 hours booking
                            if (slotLength === 60 * 24) {
                                var currentDay = car.days[day.format('YYYY-MM-DD')];
                                var key = currentDay[0].cars[0];
                                for ( var i = 0, ii = fields.length; i < ii; i++ ) {
                                    fields[i].style.display = '';
                                }
                                onSlotClick(key);
                                setTimeout(function() {
                                    if (fields.length > 0) {
                                        var found = false;
                                        // Find the first "real" module and scroll to it
                                        for ( var i = 0, ii = fields.length; i < ii; i++) {
                                            if (fields[i].scrollIntoView && fields[i].tagName === 'DIV') {
                                                found = fields[i];
                                                break;
                                            }
                                        }
                                        if (found) {
                                            found.scrollIntoView({behavior: 'smooth', block: 'nearest'});
                                        }
                                    }
                                }, 500);


                            } else {

                                renderSlots(eventSlotsListContainer, currentDay, day, function(key) {

                                    for ( var i = 0, ii = fields.length; i < ii; i++ ) {
                                        fields[i].style.display = '';
                                    }

                                    onSlotClick(key);

                                    setTimeout(function() {
                                        if (fields.length > 0) {
                                            var found = false;
                                            // Find the first "real" module and scroll to it
                                            for ( var i = 0, ii = fields.length; i < ii; i++) {
                                                if (fields[i].scrollIntoView && fields[i].tagName === 'DIV') {
                                                    found = fields[i];
                                                    break;
                                                }
                                            }
                                            if (found) {
                                                found.scrollIntoView({behavior: 'smooth', block: 'nearest'});
                                            }
                                        }
                                    }, 500);

                                });

                                eventSlotsContainer.classList.add('testvehicleslots--hours-container-open');

                                setTimeout(function() {
                                    eventSlotsContainer.scrollIntoView && eventSlotsContainer.scrollIntoView({behavior: 'smooth', block: 'center'});
                                }, 200);

                            }

                        });


                        eventCalendar.innerHTML = '';
                        eventCalendar.appendChild(oneMonth);
                        eventCalendarContainer.classList.add('testvehicleslots--event-calendar-open');
                        setTimeout(function() {
                            oneMonth.scrollIntoView && oneMonth.scrollIntoView({behavior: 'smooth', block: 'center'});
                        }, 200);
                    }
                });
                eventCarsContainer.appendChild(carElement);
            })(car);

        }
    }

}


exports.renderMonth = renderMonth;
exports.renderCalendar = renderCalendar;
exports.renderCar = renderCar;



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/testvehicleslots/testvehicleslots-calendar-renderer.js